export const tipChoices = {
    NO_TIP: 'NO_TIP',
    TIP: 'TIP',
    COFFEE: 'COFFEE',
    REMIND_ME_LATER: 'REMIND_ME_LATER',
};
